import {useState} from 'react';
import clsx from 'clsx';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

function to2Digit(v: string) {
  return v.padStart(2, '0');
}

function isDateValid(year: string, month: string, day: string) {
  if (!year || !month || !day) {
    return false;
  }
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  return date.getFullYear() === Number(year) && date.getMonth() === Number(month) - 1 && date.getDate() === Number(day);
}

interface DateInputProps {
  initialDate?: Date;
  isError: boolean;

  onChange(date: Date | null | undefined): void;
}

function DateInput({initialDate, onChange, isError}: DateInputProps) {
  const {t} = useInferableTranslation();

  const [year, setYear] = useState(() => (initialDate ? String(initialDate.getFullYear()) : ''));
  const [month, setMonth] = useState(() => (initialDate ? to2Digit(String(initialDate.getMonth() + 1)) : ''));
  const [day, setDay] = useState(() => (initialDate ? to2Digit(String(initialDate.getDate())) : ''));

  function onChangeDate(nextYear: string, nextMonth: string, nextDay: string) {
    setYear(nextYear);
    setMonth(nextMonth);
    setDay(nextDay);

    if (nextYear.length === 4 && nextMonth.length === 2 && nextDay.length === 2 && isDateValid(nextYear, nextMonth, nextDay)) {
      onChange(new Date(Number(nextYear), Number(nextMonth) - 1, Number(nextDay)));
    } else if (!nextYear && !nextMonth && !nextDay) {
      /**
       * [2025-09-25:Jeyoung Lee]
       * 모두 비어있으면 undefined, 비어있지 않은데 invalid면 null 반환
       */
      onChange(undefined);
    } else {
      onChange(null);
    }
  }

  const onYearChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 4);
    onChangeDate(value, month, day);
  };
  const onMonthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 2);
    onChangeDate(year, value, day);
  };
  const onDayChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 2);
    onChangeDate(year, month, value);
  };

  return (
    <>
      <div className="input_info year">
        <label
          htmlFor="birthYear"
          className="blind"
        >
          {t('T30497')}
        </label>
        <div className={clsx('input_box input_box_field', {input_error: isError})}>
          <input
            type="text"
            className="input_text body_large_r"
            placeholder="YYYY"
            inputMode="numeric"
            maxLength={4}
            aria-invalid={isError}
            value={year}
            onChange={onYearChange}
          />
        </div>
      </div>
      <div className="input_info">
        <label
          htmlFor="birthMonth"
          className="blind"
        >
          {t('T30498')}
        </label>
        <div className={clsx('input_box input_box_field', {input_error: isError})}>
          <input
            className="input_text body_large_r"
            placeholder="MM"
            type="text"
            inputMode="numeric"
            maxLength={2}
            aria-invalid={isError}
            value={month}
            onChange={onMonthChange}
          />
        </div>
      </div>
      <div className="input_info">
        <label
          htmlFor="birthDay"
          className="blind"
        >
          {t('T30499')}
        </label>
        <div className={clsx('input_box input_box_field', {input_error: isError})}>
          <input
            className="input_text body_large_r"
            type="text"
            inputMode="numeric"
            maxLength={2}
            placeholder="DD"
            aria-invalid={isError}
            value={day}
            onChange={onDayChange}
          />
        </div>
      </div>
    </>
  );
}

export default DateInput;
